import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class FamilyFmeaApi {
  static async Create(data: {
    title: string;
    description?: string;
    fmeaType: number;
    responsible: string;
    sublineId?: string;
    familyId?: string;
    status: number;
  }): Promise<any> {
    const response = await ApiHandler(baseURL).post("/familyfmea", data);
    return response.data;
  }

  static async Update(fmea: {
    id: string;
    title: string;
    description?: string;
    fmeaType: number;
    responsible: string;
    sublineId?: string;
    familyId?: string;
    status: number;
  }): Promise<any> {
    const response = await ApiHandler(baseURL).put(`/familyfmea/${fmea.id}`, fmea);
    return response.data;
  }

  static async GetAllFmeas(): Promise<any> {
    const response = await ApiHandler(baseURL).get("/familyfmea/getall");
    return response.data;
  }

  static async GetByFilterAsync(
    plantIds: string[] = [],
    pageNumber: number = 1,
    pageSize: number = 10,
    sortField: string = "code",
    sortDirection: string = "asc",
    code?: string,
    title?: string,
    fmeaType?: number,
    status?: string[],
    familyIds?: string[],
    productionUnitIds?: string[],
    areaIds?: string[],
    lineIds?: string[],
    subLineIds?: string[],
  ): Promise<any> {
    let url = `/familyfmea/filter?`;

    // Paginação e ordenação
    url += `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    url += `&sortField=${encodeURIComponent(sortField)}`;
    url += `&sortDirection=${encodeURIComponent(sortDirection)}`;

    // Filtros básicos
  if (title) url += `&title=${encodeURIComponent(title)}`;
  if (fmeaType !== undefined) url += `&fmeaType=${fmeaType}`;
  if (code) url += `&code=${encodeURIComponent(code)}`;

    // Filtros encadeados (arrays)
    plantIds.forEach((id) => {
      url += `&plantIds=${encodeURIComponent(id)}`;
    });
    productionUnitIds?.forEach((id) => {
      url += `&productionUnitIds=${encodeURIComponent(id)}`;
    });
    areaIds?.forEach((id) => {
      url += `&areaIds=${encodeURIComponent(id)}`;
    });
    lineIds?.forEach((id) => {
      url += `&lineIds=${encodeURIComponent(id)}`;
    });
    subLineIds?.forEach((id) => {
      url += `&subLineIds=${encodeURIComponent(id)}`;
    });
    familyIds?.forEach((id) => {
      url += `&familyIds=${encodeURIComponent(id)}`;
    });
    status?.forEach((s) => {
      url += `&status=${encodeURIComponent(s)}`;
    });

    return ApiHandler(baseURL).get(url);
  }

  static async GetById(id: string): Promise<any> {
    const response = await ApiHandler(baseURL).get(`/familyfmea/${id}`);
    return response.data;
  }

  static async Delete(id: string): Promise<any> {
    const response = await ApiHandler(baseURL).delete(`/familyfmea/${id}`);
    return response.data;
  }
  static async GetFamilyFailures(familyFmeaId: string): Promise<any> {
    return ApiHandler(baseURL).get(`/fmeas/${encodeURIComponent(familyFmeaId)}/family-failures`);
  }
  static async ImportFailures(
    productFmeaId: string,
    payload: Array<{ failureId: string; apply: boolean }>
  ): Promise<any> {
    return ApiHandler(baseURL).post(
      `/fmeas/${encodeURIComponent(productFmeaId)}/import-failures`,
      payload
    );
  }
    static async GetByFamily(
      familyId: string
    ): Promise<any> {
      const response = await ApiHandler(baseURL).get(
        `/familyfmea/family/${encodeURIComponent(familyId)}`
      );
      return response.data;
    }

    static async GetActiveFamilyFmeasByFamilyId(
      familyId: string
    ): Promise<any> {
      const response = await ApiHandler(baseURL).get(
        `/familyfmea/family/${encodeURIComponent(familyId)}/active`
      );
      return response.data;
    }
}